// Create a vue app
import { createApp } from 'vue';
import RecordedTrails from "./RecordedTrails.vue";

declare global {
  interface Window {
    recordedTrailsAppConfig?: Record<string, any>
  }
}

function mountRecordedTrailsApp (elementId: string, config: Record<string, any>) {
  const el = document.getElementById(elementId)
  if (!el) return

  window.recordedTrailsAppConfig = config
  const app = createApp(RecordedTrails)
  app.mount(`#${elementId}`)
}

const privateEl = document.getElementById('recorded-trails')
const publicEl = document.getElementById('public-recorded-trails-app')

if (privateEl) {
  mountRecordedTrailsApp('recorded-trails', { context: 'private' })
} else if (publicEl) {
  let appConfig: Record<string, any> = { context: 'public' }
  if (publicEl.dataset?.appConfig) {
    try {
      appConfig = { ...appConfig, ...JSON.parse(publicEl.dataset.appConfig) }
    } catch (err) {
      console.warn('Failed to parse recorded trails app config dataset:', err)
    }
  }
  mountRecordedTrailsApp('public-recorded-trails-app', appConfig)
}
